import React, { useContext, useEffect, useState } from "react";
import Utils from "../../utils";
import AuthUtil from "../../utils/auth";
import { UserContext } from "../../context";
import CustomDrawer from "../../../src/components/drawer";
import {
  SettingOutlined,
  MailOutlined,
  FundOutlined,
  PhoneOutlined,
  LockOutlined,
  LogoutOutlined,
  CloseOutlined,
  IdcardOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Avatar, Modal } from "antd";
import styles from "./layout-header.module.css";
import GenericPopover from "../pop-over";
import { TUser } from "../../types/config";
import SettingsForm from "./settings-form";
import ActionCard from "../action-card/action-card";
import SendOTP from "../../pages/auth/reset-password";
import { eAuthStatus } from "../../utils/enum";
import { getToken, messaging } from "../../firebase/firebase-config";
import useFetch from "../../hooks/useFetch";

type Options = {
  value: string;
  label: string;
};

export default function UserProfile() {
  const { post } = useFetch();
  const vapidKey = process.env.VAPID_KEY;
  const context: any = useContext(UserContext);
  const [userDetails, setUserDetails] = useState<any>(context.user);
  const [moduleId, setModuleId] = useState("");
  const navigate = useNavigate(); // Replaces Next.js router
  const [options, setOptions] = useState<Options[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  useEffect(() => {
    setUserDetails(context.user);
    fetchListOfModelData();
    setModuleId(context.ActiveModuleId);    
  }, [context.user]);

  const setupNotification = async (action: eAuthStatus) => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const fcmToken = await getToken(messaging, { vapidKey });
        if (fcmToken) {
          console.log("FCM Token:", fcmToken);
          const payload = {
            data: {
              action: action,
              fcmToken: fcmToken,
            },
          };
          await post("/registerFCMToken", payload);
        } else {
          console.warn("No token received");
        }
      }
    } catch (err) {
      console.error("Notification setup error:", err);
    }
  };

  function signOut() {
    setupNotification(eAuthStatus.LOGOUT)
      .then(() => {
        AuthUtil.logout();
        Utils.redirectUrl(`/login`);
      })
      .catch((err) => {
        console.error("Error during notification setup:", err);
        AuthUtil.logout();
        Utils.redirectUrl(`/login`);
      });
  }

  const handleClick = () => {
    navigate("/dashboard/user-profile/form"); // Replaces router.push
  };

  const handlePasswordClick = () => {
    setIsPasswordModalOpen(true); // Open Change Password modal
  };

  const handleModalOk = () => {
    setIsModalOpen(false); // Close modal
  };

  const handleModalCancel = () => {
    setIsModalOpen(false); // Close modal
    setIsPasswordModalOpen(false);
  };

  const fetchListOfModelData = async () => {};

  const handleSettingsClick = () => {
    setIsModalOpen(true); // Open modal on Settings click
  };

  const UserProfileContent: React.FC<{ onCloseDrawer: () => void }> = ({
    onCloseDrawer,
  }) => (
    <>
      <CloseOutlined
        style={{
          cursor: "pointer",
          padding: "1rem",
          fontSize: "1rem",
          fontFamily: "Montserrat-SemiBold",
          color: "white",
        }}
        onClick={onCloseDrawer}
      />
      <div className={styles.userBox}>
        <div className={styles.pencil}>
          <Avatar
            size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}
            src={userDetails?.profileImage || ""}
          >
            {userDetails?.fullName || ""}
          </Avatar>
          <span className={styles.userName}>
            {userDetails?.fullName
              ? userDetails?.fullName
              : userDetails?.emailId}
          </span>
        </div>
        <div className={styles.userProfile}>
         
          <div className={styles.profileWrapper}>
            <MailOutlined style={{ fontSize: "1.2rem" }} />
            <span style={{ width: "90%" }}>{userDetails?.emailId}</span>
          </div>
          <div className={styles.profileWrapper}>
            <PhoneOutlined style={{ fontSize: "1.2rem" }} />
            <span style={{ width: "90%" }}>{userDetails?.mobileNumber}</span>
          </div>
          <div className={styles.profileWrapper}>
            <IdcardOutlined style={{ fontSize: "1.2rem" }} />
            <span style={{ width: "90%" }}>
              {userDetails?.roles?.name}
            </span>
          </div>
          <div
            className={styles.profileWrapper}
            onClick={() => {
              handlePasswordClick();
              onCloseDrawer();
            }}
            style={{ cursor: "pointer" }}
          >
            <LockOutlined style={{ fontSize: "1.2rem" }} />
            <span style={{ width: "90%" }}>Change Password</span>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <GenericPopover
        placement="bottomLeft"
        content={
          <div className="standardActionBox">
            {" "}
            <CustomDrawer
              key={`user-profile-drawer`}
              trigger={
                <ActionCard text="Settings">
                  <SettingOutlined style={{ fontSize: "1.3rem" }} />
                </ActionCard>
              }
              component={UserProfileContent}
              componentProps={{}}
              title="User Profile"
              width={300}
            />
            <ActionCard text="Sign Out" onClick={signOut}>
              <LogoutOutlined style={{ fontSize: "1.2rem" }} />
            </ActionCard>
          </div>
        }
        icon={
          <UserOutlined style={{ fontSize: "22px", color: "white" }} />
        }
      />
      <Modal
        title="Change Password"
        open={isPasswordModalOpen}
        onOk={() => { }}
        onCancel={handleModalCancel}
        footer={null}
        okText=""
        cancelText=""
        width="31%"
      >
        <SendOTP handleModalCancel={handleModalCancel} />
      </Modal>
      <Modal
        title="Settings"
        open={isModalOpen}
        onOk={() => handleModalOk()}
        onCancel={() => handleModalCancel()}
        footer={null}
      >
        <SettingsForm onClose={handleModalCancel}></SettingsForm>
      </Modal>
    </>
  );
}
